import React from 'react';
import Page from '../../layout/Page';
import PointsAwards from './PointsAwards';
import RoleProtected, { userRoles } from '../../RoleProtected';
import { HasFeature, Features } from '../../RequireFeature';

const LoyaltyPointAwardsPage = () => {
    const hasAwardEnhancement = HasFeature(Features.AwardEnhancement);
    if (!hasAwardEnhancement) return null;

    return (
        <RoleProtected roles={userRoles.accountConfiguration}>
            <Page title='Loyalty Point Awards' icon='mobile'>
                <PointsAwards />
            </Page>
        </RoleProtected>
    );
}

export default LoyaltyPointAwardsPage;
